// Discharge summary section form field enum
export enum DischargeSummaryFormField {
  TYPES_OF_SERVICES = 'typesOfServices',
  SERVICE_FREQUENCY = 'serviceFrequency',
  LAST_DATE_OF_SERVICE = 'lastDateOfService',
  DISCHARGE_CONDITION = 'dischargeCondition',
  REASON_FOR_DISCHARGE = 'reasonForDischarge',
  LABORATORY_DATA = 'laboratoryData',
  PLAN_OF_CARE_OUTCOMES = 'planOfCareOutcomes',
  DISCHARGE_INSTRUCTIONS = 'dischargeInstructions',
  POST_DISCHARGE_TREATMENT = 'postDischargeTreatment',
  POST_DISCHARGE_GOALS = 'postDischargeGoals'
}
